import React from 'react';

const NFTCard = ({ id, title, imageUrl, rank, score, price, held, marketplaceUrl }) => {
  return (
    <div className="nft-card">
      <div className="nft-card__image">
        <img 
          src={imageUrl} 
          alt={title}
          onError={(e) => {
            e.target.src = `data:image/svg+xml;base64,${btoa(`
              <svg width="200" height="200" xmlns="http://www.w3.org/2000/svg">
                <rect width="200" height="200" fill="#131722"/>
                <text x="100" y="100" font-family="Arial" font-size="16" fill="#556080" text-anchor="middle" dy=".3em">NFT ${id}</text>
              </svg>
            `)}`;
          }}
        />
      </div>

      <div className="nft-card__body">
        <h3 className="nft-card__title">{title}</h3>

        <div className="nft-card__badges">
          <span className="badge badge--rank">Rank: #{rank}</span>
          <span className="badge badge--score">Score: {score}</span>
        </div>

        <div className="nft-card__info-row">
          {price ? (
            <div className="info-box info-box--price">
              <span className="label">Price</span>
              <span className="value">{price}</span>
            </div>
          ) : (
            <div className="info-box info-box--held">
              <i className="icon-diamond">💎</i>
              <span className="value">HELD</span>
            </div>
          )}
        </div>
      </div>

      <div className="nft-card__footer">
        <a 
          className="btn btn--market" 
          href={marketplaceUrl} 
          target="_blank" 
          rel="noopener noreferrer"
        >
          <span className="btn__icon">🔗</span>
          <span className="btn__text">objkt</span>
        </a>
      </div>
    </div>
  );
};

export default NFTCard;
